import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=63a06722&scoped=true"
import script from "./AddCoupon.vue?vue&type=script&lang=js"
export * from "./AddCoupon.vue?vue&type=script&lang=js"
import style0 from "./AddCoupon.vue?vue&type=style&index=0&id=63a06722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a06722",
  null
  
)

export default component.exports